
import { useForm } from "react-hook-form"
import type { User } from "firebase/auth"
import { api } from "../../core"
import type { LiveId, SelectionId, SelectionSequenceId, SpaceKey } from "popopo-msg"

type SelectionNominateForms = {
  kind: "pseudo-nominate" | "nominate"
  count: number
}

export const SelectionNominateForm = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId; selectionId: SelectionId, sequence: SelectionSequenceId | null }) => {
  const form = useForm<SelectionNominateForms>({
    mode: "onBlur",
    defaultValues: {
      kind: "pseudo-nominate",
      count: 3,
    },
  })

  const { spaceKey, liveId, selectionId } = props
  const { isSubmitting, isValid } = form.formState

  const onSubmit = async (body: SelectionNominateForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      if (body.kind === "pseudo-nominate") {
        await api.POST("/api/v2/spaces/{space_key}/lives/{live_id}/selections/{selection_id}/sequences/pseudo-nominate", {
          params: {
            path: {
              space_key: spaceKey,
              live_id: liveId,
              selection_id: selectionId,
            },
          },
          headers: {
            authorization: `Bearer ${idToken}`,
          },
          body: {
            ...body,
            sequence: {
              id: props.sequence ?? "",
            },
          },
        })
      } else {
        await api.POST("/api/v2/spaces/{space_key}/lives/{live_id}/selections/{selection_id}/sequences/nominate", {
          params: {
            path: {
              space_key: spaceKey,
              live_id: liveId,
              selection_id: selectionId,
            },
          },
          headers: {
            authorization: `Bearer ${idToken}`,
          },
          body: {
            ...body,
            sequence: {
              id: props.sequence ?? "",
            },
          },
        })
      }
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
        <div className="form-floating">
          <select className="form-control" disabled={isSubmitting} {...form.register("kind")}>
            <option value={"pseudo-nominate"}>Pseudo Nominate</option>
            <option value={"nominate"}>Nominate</option>
          </select>
          <label>Kind</label>
        </div>

        <div className="form-floating">
          <input
            type="number"
            className="form-control"
            {...form.register("count", {
              valueAsNumber: true,
            })}
            disabled={isSubmitting}
          />
          <label>Count</label>
        </div>

        <button type="submit" className="btn btn-warning form-control" disabled={isSubmitting || !isValid}>
          Nominate
        </button>
      </form>
    </>
  )
}
